import { getLogicNodeSchema } from '../Hasp/properties/v2/logic/index.js';
import { deserializeGraph, serializeGraph } from '../graph/graphSerialization.js';

/**
 * Design-file form of a page logic graph (see graphSerialization.js). A wire
 * starts at a UI object (`from: { objectId, port }`: an event source or a
 * compared value) or ends at one (`to: { objectId, port }`: a GPIO binding).
 */
export function serializeLogicGraph(graph, haspidOfObject) {
    return serializeGraph(graph, haspidOfObject);
}

/** @returns {{ graph, diagnostics: string[] }} — invalid entries are dropped and reported. */
export function deserializeLogicGraph(data, uuidOfHaspid) {
    return deserializeGraph(data, uuidOfHaspid, { getNodeSchema: getLogicNodeSchema, label: 'Logic', objectTargets: true });
}
